import store from '@/store';
const User = () => import(/* webpackChunkName: "manage" */'@/components/pages/user/User');
const OperateUserPage = () => import(/* webpackChunkName: "manage" */'@/components/pages/user/OperateUserPage');
const Role = () => import(/* webpackChunkName: "manage" */'@/components/pages/role/Role');
const OperateRolePage = () => import(/* webpackChunkName: "manage" */'@/components/pages/role/OperateRolePage');
const Dictionary = () => import(/* webpackChunkName: "manage" */'@/components/pages/dictionary/Dictionary');
const Category = () => import(/* webpackChunkName: "manage" */'@/components/pages/category/Category');
const Depart = () => import(/* webpackChunkName: "manage" */'@/components/pages/depart/Depart');
const SupGroup = () => import(/* webpackChunkName: "manage" */'@/components/pages/supGroup/SupGroup');
const TopMenu = () => import(/* webpackChunkName: "base" */'@/components/common/TopMenu');
const routerMapping = {
  'SYS_USER_QUERY': '/system/essential/user',
  'SYS_ROLE_QUERY': '/system/essential/role',
  'SYS_DEPART_QUERY': '/system/essential/depart',
  'SYS_SUP_GROUP_QUERY': '/system/essential/sup-group',
  'SYS_CATEGORY_QUERY': '/system/essential/category',
  'SYS_DIC_QUERY': '/system/essential/dictionary',
}
export default [
  {
    path: 'essential',
    name: 'essential',
    redirect: () => {
      let index = store.state.tab.workPages.findIndex(p => p.secondParent === '/system/essential');
      if (index > -1) {
        return store.state.tab.workPages[index].routePath;
      } else {
        const roleIds = store.state.base.roleIds;
        let router = '/system/essential/user';
        for (var item in routerMapping) {
          if (roleIds.includes(item)) {
            router = routerMapping[item];
            break;
          }
        }
        return router;
      }
    },
    component: TopMenu,
    meta: {
      roles: [
        'SYS_USER_QUERY',
        'SYS_ROLE_QUERY',
        'SYS_DEPART_QUERY',
        'SYS_SUP_GROUP_QUERY',
        'SYS_CATEGORY_QUERY',
        'SYS_DIC_QUERY',
      ],
      title: '基础数据',
      activeMenu: '/system/essential',
      componentName: 'TopMenu'
    },
    children: [
      {
        path: 'user',
        name: 'user',
        meta: {
          roles: ['SYS_USER_QUERY'],
          title: '用户管理',
          componentName: 'User',
          breadcrumb: [
            {
              name: '用户管理',
              path: '/system/essential/user'
            }
          ],
        },
        component: User
      },
      {
        path: 'edit-user/:id',
        props: true,
        name: 'editUser',
        meta: {
          roles: ['SYS_USER_UPDATE'],
          title: '编辑用户',
          hidden: true,
          activeMenu: '/system/essential/user',
          componentName: 'OperateUser',
          breadcrumb: [
            {
              name: '用户管理',
              path: '/system/edit-user/:id'
            }
          ]
        },
        component: OperateUserPage
      },
      {
        path: 'create-user',
        name: 'createUser',
        meta: {
          roles: ['SYS_USER_ADD'],
          title: '新建用户',
          hidden: true,
          activeMenu: '/system/essential/user',
          componentName: 'OperateUser',
          breadcrumb: [
            {
              name: '用户管理',
              path: '/system/create-user'
            }
          ]
        },
        component: OperateUserPage
      },
      {
        path: 'role',
        name: 'role',
        meta: {
          roles: ['SYS_ROLE_QUERY'],
          title: '角色管理',
          componentName: 'Role',
          breadcrumb: [
            {
              name: '角色管理',
              path: '/system/essential/role'
            }
          ]
        },
        component: Role
      },
      {
        path: 'edit-role/:id',
        props: true,
        name: 'editRole',
        meta: {
          roles: ['SYS_ROLE_UPDATE'],
          title: '编辑角色',
          hidden: true,
          activeMenu: '/system/essential/role',
          componentName: 'OperateRole',
          breadcrumb: [
            {
              name: '角色管理',
              path: '/system/essential/role'
            },
            {
              name: '编辑角色',
              path: '/system/essential/edit-role/:id'
            }
          ]
        },
        component: OperateRolePage
      },
      {
        path: 'create-role',
        name: 'createRole',
        meta: {
          roles: ['SYS_ROLE_ADD'],
          title: '新建角色',
          hidden: true,
          activeMenu: '/system/essential/role',
          componentName: 'OperateRole',
          breadcrumb: [
            {
              name: '角色管理',
              path: '/system/essential/role'
            },
            {
              name: '新建角色',
              path: '/system/essential/create-role'
            }
          ]
        },
        component: OperateRolePage
      },
      {
        path: 'depart',
        name: 'depart',
        meta: {
          roles: ['SYS_DEPART_QUERY'],
          title: '机构管理',
          componentName: 'Depart',
          breadcrumb: [
            {
              name: '机构管理',
              path: '/system/essential/depart'
            }
          ]
        },
        component: Depart
      },
      {
        path: 'sup-group',
        name: 'supGroup',
        meta: {
          roles: ['SYS_SUP_GROUP_QUERY'],
          title: '支持组管理',
          componentName: 'SupGroup',
          breadcrumb: [
            {
              name: '支持组管理',
              path: '/system/essential/sup-group'
            }
          ]
        },
        component: SupGroup
      },
      {
        path: 'category',
        name: 'category',
        meta: {
          roles: ['SYS_CATEGORY_QUERY'],
          title: '分类管理',
          componentName: 'Category',
          breadcrumb: [
            {
              name: '分类管理',
              path: '/system/essential/category'
            }
          ]
        },
        component: Category
      },
      {
        path: 'dictionary',
        name: 'dictionary',
        meta: {
          roles: ['SYS_DIC_QUERY'],
          title: '数据字典',
          componentName: 'Dictionary',
          breadcrumb: [
            {
              name: '数据字典',
              path: '/system/essential/dictionary'
            }
          ]
        },
        component: Dictionary
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/essential.js